import React from 'react';
import { fromJS } from 'immutable';
import { useController } from '../../useController';
import { useEvent } from '../../useEvents';
import { getInitialEditorState } from './NoteInput.helpers';
import { EmptyNote, ReadOnlyNote, EditingNote } from './Components/NoteInput.Views';
import * as actions from './NoteInput.Actions';

export const MAX_CHARS = 1000;
export const EMPTY_NOTE = fromJS({ text: '', htmlText: '', taggedParties: [] });

export const EDIT_NOTE_VIEW = 'edit-note';
export const READ_ONLY_VIEW = 'read-only';
export const EMPTY_NOTE_VIEW = 'empty-note';

export const VIEW_MAP = {
  [EDIT_NOTE_VIEW]: EditingNote,
  [READ_ONLY_VIEW]: ReadOnlyNote,
  [EMPTY_NOTE_VIEW]: EmptyNote,
  loading: null,
};

const emptyState = {
  usersToTag: [],
  charLeft: MAX_CHARS,
  textValue: '',
  inputData: '',
  isEditing: false,
  isUploading: false,
};

export const NoteInputContext = ({
  task,
  note,
  notesService,
  appContext,
  showAddNewNote = false,
  showEditNote = false,
  disableSubmitBtn = null,
}) => {
  const loggedUser = appContext.appState.get('user');
  const noteText = note?.get('text') || '';

  const initView = getInitView(note, showAddNewNote, showEditNote);
  const initState = fromJS({
    ...emptyState,
    editorState: getInitialEditorState(note),
    textValue: noteText,
    view: initView,
  });
  const textAreaRef = React.useRef(null);
  const taskId = task.get('id');

  const [state, controller] = useController(actions, initState, {
    info,
    task,
    note,
    notesService,
    disableSubmitBtn,
    ...appContext,
  });

  useEvent(`notes:refresh-tag-users:${taskId}`, controller.getUsersToTagInNotes);

  const isLimitReached = state.get('charLeft') < 0;
  React.useEffect(() => {
    controller.getUsersToTagInNotes();
  }, [controller, taskId]);

  React.useEffect(() => {
    if (disableSubmitBtn) disableSubmitBtn(isLimitReached);
  }, [disableSubmitBtn, isLimitReached]);

  return { state, controller, textAreaRef, loggedUser, showAddNewNote };
};

function info() {
  const taskId = this.task.get('id');
  const jobId = this.task.getIn(['job', 'id']);
  const user = this.appState.get('user');
  return { user, taskId, jobId };
}

function getInitView(note, showAddNewNote, showEditNote) {
  const noteText = note?.get('text');
  const isEmpty = !noteText || noteText.length < 1;

  if (showEditNote) return EDIT_NOTE_VIEW;
  if (!isEmpty) return READ_ONLY_VIEW;
  if (showAddNewNote) return EMPTY_NOTE_VIEW;
  return 'loading';
}
